// extracted by mini-css-extract-plugin
export default {"div":"updateBar_div__JsBbK","button":"updateBar_button__keyun"};